module.exports = __webpack_public_path__ + "img/logo-mini.79dd7212.svg";